import { render, staticRenderFns } from "./AbaModelo.vue?vue&type=template&id=380785a8"
import script from "./AbaModelo.vue?vue&type=script&lang=js"
export * from "./AbaModelo.vue?vue&type=script&lang=js"
import style0 from "./AbaModelo.vue?vue&type=style&index=0&id=380785a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports